export default "__VITE_ASSET__CDfSzIHN__"